// 导入组件，组件必须声明 name
import ySelect from "./src/index.vue";
// 为组件提供 install 安装方法，供按需引入
ySelect.install = function(Vue) {
    Vue.component(ySelect.name, ySelect);
};
// 默认导出组件
export default ySelect;